import { useEffect, useState, useRef } from 'react'

import { useGetSearchProductsQuery } from 'integration/resources/products'
import { Box, HStack, Input, Skeleton, useMediaQuery, VStack } from 'native-base'
import { ProductListSearch } from 'organisms/ProductListSearch/ProductListSearch'
import { ProductsTrendingDesktop } from 'organisms/ProductListSearch/ProductsTrendingDesktop'
import { useLocation } from 'react-router-dom'

import { ProductSearchEmpty } from './ProductSearchEmpty'

export const ProductSearchDesktop = () => {
  const [searchTerm, setSearchTerm] = useState('')

  const [isFocused, setIsFocused] = useState(false)

  const { data, isLoading } = useGetSearchProductsQuery({
    name: searchTerm
  })

  const isError = data?.status === 404

  const searchInputRef = useRef<HTMLInputElement | null>(null)

  const searchContainerRef = useRef<HTMLDivElement | null>(null)

  const productsListRef = useRef<HTMLDivElement | null>(null)

  const location = useLocation()

  const handleSearch = (search: string) => {
    setSearchTerm(search)
  }

  const handleProductClick = (productName: string) => {
    setSearchTerm(productName)
  }

  useEffect(() => {
    setSearchTerm('')

    setIsFocused(false)
  }, [location.pathname])

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        productsListRef.current &&
        !productsListRef.current.contains(event.target as Node) &&
        searchInputRef.current &&
        !searchInputRef.current.contains(event.target as Node)
      ) {
        setIsFocused(false)

        setSearchTerm('')
      }
    }

    document.addEventListener('click', handleClickOutside)

    return () => {
      document.removeEventListener('click', handleClickOutside)
    }
  }, [])

  const [isSmallScreen] = useMediaQuery({
    minWidth: 1500
  })

  return (
    <HStack>
      <HStack
        display="grid"
        position="relative"
        justifyContent="center"
        alignItems="center"
        space="md"
        w={isSmallScreen ? '704px' : '620px'}
        m="auto"
        pb="4"
        pt="4"
        ref={searchContainerRef}>
        <HStack>
          <Input
            ref={searchInputRef}
            placeholder="Buscar produtos..."
            value={searchTerm}
            onChangeText={handleSearch}
            onFocus={() => setIsFocused(true)}
            w={isSmallScreen ? '704px' : '620px'}
            fontSize="16px"
            _focus={{ backgroundColor: '#FCFCFC' }}
            h={10}
            py={2}
            pl={5}
            borderWidth="2"
            borderColor="gray.300"
          />
        </HStack>

        {isFocused && (
          <HStack
            maxHeight="560px"
            w={isSmallScreen ? '690px' : '620px'}
            position="absolute"
            display="flex"
            backgroundColor="#FCFCFC"
            borderBottomLeftRadius={8}
            borderBottomRightRadius={8}
            zIndex={9999}
            top="56px"
            right="50%"
            //@ts-ignore
            style={{
              transform: [
                {
                  translateX: '50%'
                }
              ],
              elevation: 7,
              boxShadow: '0 4px 10px rgba(0, 0, 0, 0.3)'
            }}
            ref={productsListRef}>
            <ProductsTrendingDesktop
              searchTerm={searchTerm}
              isError={isError}
              handleProductClick={handleProductClick}
            />

            {searchTerm && !isLoading && !isError && (
              <HStack mt={6}>
                <ProductListSearch products={data?.data ?? []} />
              </HStack>
            )}

            {isLoading && (
              <Box m={8}>
                <VStack w={47} space={4}>
                  <Skeleton h={47} rounded="10px" />
                  <VStack justifyContent="space-evenly">
                    <Skeleton.Text width={47} lines={1} pb={2} />
                    <Skeleton.Text width={47} lines={1} pb={2} />
                    <Skeleton.Text width={47} lines={1} />
                  </VStack>
                </VStack>
              </Box>
            )}

            {isError && (
              <Box height="400px" alignItems="center" marginLeft={isSmallScreen ? '135px' : '80px'}>
                <ProductSearchEmpty />
              </Box>
            )}
          </HStack>
        )}
      </HStack>
    </HStack>
  )
}
